import { getTenantId } from '../services/tenant/tenantService.js';
import yn from 'yn';

export const config = {
    S3_BASE_URL: process.env.REACT_APP_S3_BASE_URL,
    get CLIENT_ID() {
        return getTenantId();
    }
};

